<form [formGroup]="companyGroup" class="pb2 flex flex-col">

  <h3 class="mat-headline-6 mt2 flex flex-row justify-start items-center w-full">
    <mat-icon class="icon-small mr1">list_alt</mat-icon>
    <span translate="">Company information</span>
  </h3>

  <unite-company-autocomplete [control]="companyGroup.get('name')" [label]="'Search company by name' | translate" class="full-width" (companySelected)="companyProfileSelected($event)"></unite-company-autocomplete>

  <mat-form-field appearance="outline" class="small-field">
    <mat-label translate="">Chamber of commerce number</mat-label>
    <input matInput="" type="text" formControlName="chamberOfCommerceNumber" minLength="8" maxLength="8" required="" autocomplete="off">
  </mat-form-field>

  <unite-legalform-input [legalFormControl]="companyGroup.get('legalForm')" class="flex flex-col"></unite-legalform-input>

  <mat-form-field appearance="outline" class="small-field">
    <mat-label translate="">Statutory name</mat-label>
    <input matInput="" type="text" formControlName="statutoryName" minlength="1" autocomplete="off">
  </mat-form-field>

  <mat-form-field appearance="outline" class="small-field">
    <mat-label translate="">Statutory location</mat-label>
    <input matInput="" type="text" formControlName="statutoryLocation" minlength="1" autocomplete="off">
  </mat-form-field>

  <mat-form-field appearance="outline" class="small-field">
    <mat-label translate="">Founding date</mat-label>
    <input matInput="" [matDatepicker]="picker" formControlName="foundingDate" autocomplete="off">
    <mat-datepicker-toggle matSuffix="" [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker=""></mat-datepicker>
  </mat-form-field>

  <unite-address-input-v2 class="mt2 flex flex-col" formGroupName="address">
    <h3 class="mat-headline-6 mt2 flex flex-row justify-start items-center w-full">
      <mat-icon class="icon-small mr1">place</mat-icon>
      <span translate="">Address</span>
    </h3>
  </unite-address-input-v2>

  <h3 class="mat-headline-6 mt2 flex flex-row justify-start items-center w-full">
    <mat-icon class="icon-small mr1">phone_iphone</mat-icon>
    <span translate="">Contact information</span>
  </h3>

  <unite-contact-autocomplete [label]="'Contact person' | translate" [control]="companyGroup.get('contact')"></unite-contact-autocomplete>

  <div class="flex flex-row space-x-[3%] basis-full">
    <mat-form-field appearance="outline" class="basis-1/2">
      <mat-label translate="">Telephone</mat-label>
      <input matInput="" type="text" formControlName="phone" autocomplete="off" pattern="((\+\d{8,14})|([0]\d{9}))">
    </mat-form-field>

    <mat-form-field appearance="outline" class="basis-1/2">
      <mat-label translate="">Mobile</mat-label>
      <input matInput="" type="text" formControlName="mobile" autocomplete="off" pattern="((\+\d{8,14})|([0]\d{9}))">
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline">
    <mat-label translate="">Email</mat-label>
    <input matInput="" email="" type="email" formControlName="email" autocomplete="off">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label translate="">IBAN</mat-label>
    <input matInput="" type="text" formControlName="iban" autocomplete="off">
  </mat-form-field>


  <unite-customer-settings [userControl]="companyGroup.get('adviser')" [existingControl]="companyGroup.get('existing')" [businessunitControl]="companyGroup.get('businessunit')" [isCreating]="true"></unite-customer-settings>

  <h3 class="mat-headline-6 mt2 flex flex-row justify-start items-center w-full">
    <mat-icon class="icon-small mr1">add_circle_outline</mat-icon>
    <span translate="">Add company shareholders</span>
  </h3>

  <mat-form-field appearance="outline">
    <mat-icon matPrefix="" class="mr1">search</mat-icon>
    <mat-label translate="">Search for a person or company</mat-label>
    <input matInput="" type="text" [formControl]="searchShareholderControl" [matAutocomplete]="auto" autocomplete="off">
    <div matSuffix="" class="flex items-center">
      @if (searchShareholderControlIsLoading) {
        <mat-spinner diameter="24" class="mx2"></mat-spinner>
      }
    </div>
  </mat-form-field>

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySearchValue" (optionSelected)="addShareholder($event)" class="small-autocomplete">
    @if (!searchShareholderControlIsLoading) {
      @if (searchShareholderControl.value && filteredShareholders && filteredShareholders.length == 0) {
        <mat-option>
          <span class="main bold black" translate="">Nothing found</span>
        </mat-option>
      }
      @for (filteredShareholder of filteredShareholders; track filteredShareholder) {
        <mat-option [value]="filteredShareholder" class="flex justify-between content-center items-center flex-row flex-wrap">
          @if (filteredShareholder.type === 'Company') {
            <mat-icon class="icon-small">business_center</mat-icon>
          }
          @if (filteredShareholder.type === 'Person') {
            <mat-icon class="icon-small">person_outline</mat-icon>
          }
          <span class="main bold black ">{{ filteredShareholder.name }}</span>
          @if (filteredShareholder.address) {
            <span class="sub ml2 ">{{filteredShareholder.address.addressLine1}}, {{filteredShareholder.address.city}}</span>
          }
          @if (!filteredShareholder.address) {
            <span class="sub ml2 " translate="">Unknown</span>
          }
        </mat-option>
      }
    }
  </mat-autocomplete>

  <mat-list class="boxed-list">
    @for (shareholder of shareholders; track shareholder) {
      <mat-list-item>
        @if (shareholder.customerType === 'Company') {
          <mat-icon matListItemIcon="">business_center</mat-icon>
        }
        @if (shareholder.customerType === 'Person') {
          <mat-icon matListItemIcon="">person_outline</mat-icon>
        }
        <h4 mat-line="" class="mat-headline-6">
          {{shareholder.name}}
        </h4>
        <p mat-line="" class="flex justify-start content-center items-center flex-row">
          <span class="gray mr1" translate="">Share</span>
          <strong class="mr1">{{shareholder.share}}%</strong>
          <button mat-icon-button="" (click)="changeShare(shareholder, shareholder.share - 1)">
            <mat-icon>expand_more</mat-icon>
          </button>
          <button mat-icon-button="" (click)="changeShare(shareholder, shareholder.share + 1)">
            <mat-icon>expand_less</mat-icon>
          </button>
        </p>
        <button mat-icon-button="" color="warn" (click)="removeShareholder(shareholder)">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-list-item>
    }
  </mat-list>


  <div class="mt3 flex flex-row justify-end content-center items-center w-full">
    <unite-loading-button [text]="'Add company' | translate" [loading]="loadingCreate" icon="done" (buttonClick)="create()">
    </unite-loading-button>
  </div>
</form>